export interface IDataMapperOperations {
    [key: string]: Function | undefined;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request?(request: { [k: string]: any }): {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response?(response: { [k: string]: any }): {};
}

export interface IDataMapper {
    [key: string]: IDataMapperOperations;
}

export class DataMapper {
    public dataMappings?: IDataMapper;

    constructor(dataMappings?: IDataMapper) {
        this.dataMappings = dataMappings;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public mapRequest(name: string, request: Record<string, any>) {
        if (this.dataMappings && this.dataMappings[name] && this.dataMappings[name].request) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return this.dataMappings[name]!.request!(request);
        }

        return request;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public mapResponse(name: string, response: Record<string, any>) {
        if (this.dataMappings && this.dataMappings[name] && this.dataMappings[name].response) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return this.dataMappings[name]!.response!(response);
        }

        return response;
    }
}
